






import { Component, Vue } from 'vue-property-decorator'
import { Routes } from '../router'
import CoreIcon from './CoreIcon.vue'

@Component({
    components: { CoreIcon },
})
export default class GoBackButton extends Vue {
    public routes = Routes

    public get route() {
        const currentRoute = this.$route.name
        if (currentRoute === this.routes.PLATFORM_SETTINGS) {
            return this.routes.PERSONAL_INFO
        }
        if (currentRoute === this.routes.TERMS_AND_CONDITIONS) {
            return this.routes.PERSONAL_INFO
        }
        return this.routes.PERSONAL_INFO
    }
}
